module.exports = __webpack_public_path__ + "img/pllogo.1bc60fea.svg";